module.exports = __webpack_public_path__ + "static/img/reportLoss.15a27f2b.png";